import { createApi } from "@reduxjs/toolkit/query/react";

import type { VenueDTO } from "../../../../common/types/VenueDTO";
import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

export const venueService = createApi({
  reducerPath: "venueService",
  baseQuery: createServiceBaseQuery("bffApiUri"),
  tagTypes: ["Venue"],
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getVenue: builder.query<VenueDTO, { id: number }>({
      query: ({ id }) => `/api/identity/venues/${id}`,
      providesTags: (venue) => [{ type: "Venue", id: venue?.id }],
    }),
    getVenues: builder.query<VenueDTO[], void>({
      query: () => `/api/identity/venues`,
      providesTags: [{ type: "Venue", id: "LIST" }],
    }),
  }),
});

export const { useGetVenueQuery, useGetVenuesQuery } = venueService;
